<template>
  <div id="totalBox">
    <div class="productCenterBanner">
      <div class="productBannerContent">
        <div class="productBannerTitle" >任马停系列产品</div>
        <div class="productBannerText">
                  不同于其他停车品牌的单一产品，任马停研发出了智慧停车所涉及的用户端、管理端、车牌识别系统以及智能硬件等多个产品，依据现有技术，致力于智慧停车形成了一个良性发展的闭合产业链
        </div>
      </div>
      <img src="../../assets/product/productLogo.png" class="productBannerImg"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Productcenterbanner',
  data: function () {
    return {
      msg: '1'
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 700px;
  background:rgba(247,247,247,1);
}
.productCenterBanner{
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.productBannerContent{
  width: 550px;
  height: 570px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.productBannerTitle{
  font-size:50px;
  font-weight:bold;
  color:rgba(35,24,21,1);
}
.productBannerText{
  width: 550px;
  font-size:20px;
  font-weight:400;
  color:rgba(111,110,110,1);
  line-height:39px;
  text-align: left;
  margin-top: 41px;
  word-break: break-all;
}
.productBannerImg{
  width: 540px;
  height: 570px;
  margin-left: 110px;
}
</style>



// WEBPACK FOOTER //
// src/components/productCenter/productcenterbanner.vue